<div #mapWrapper [id]="mapElId" class="osm"></div>
